export const bussinessType = {
  JOB: {
    "JOB-01": "JOB-01",
    "JOB-02": "JOB-02",
    "JOB-03": "JOB-03",
    "JOB-04": "JOB-04",
    "JOB-05": "JOB-05",
    "JOB-06": "JOB-06",
    "JOB-07": "JOB-07",
    "JOB-08": "JOB-08",
    "JOB-09": "JOB-09",
    "JOB-10": "JOB-10",
    "JOB-11": "JOB-11",
    "JOB-12": "JOB-12",
    "JOB-13": "JOB-13",
    "JOB-14": "JOB-14",
    "JOB-15": "JOB-15",
    "JOB-16": "JOB-16",
    "JOB-17": "JOB-17",
    "JOB-18": "JOB-18",
    "JOB-19": "JOB-19",
    "JOB-20": "JOB-20",
    "JOB-21": "JOB-21",
    "JOB-22": "JOB-22",
    "JOB-23": "JOB-23",
    // "JOB-24": "JOB-24",
    "JOB-25": "JOB-25",
    // "JOB-26": "JOB-26",
    "JOB-27": "JOB-27",
    "JOB-28": "JOB-28",
    "JOB-29": "JOB-29",
    "JOB-30": "JOB-30",
    "JOB-31": "JOB-31",
    "JOB-32": "JOB-32",
    "JOB-33": "JOB-33",
    "JOB-34": "JOB-34",
    "JOB-35": "JOB-35",
    "JOB-36": "JOB-36",
    "JOB-37": "JOB-37",
    "JOB-38": "JOB-38",
    "JOB-39": "JOB-39",
    "JOB-40": "JOB-40",
    "JOB-41": "JOB-41",
    "JOB-42": "JOB-42",
    "JOB-43": "JOB-43",
    "JOB-44": "JOB-44",
    "JOB-45": "JOB-45",
    "JOB-46": "JOB-46",
    "JOB-47": "JOB-47",
    "JOB-48": "JOB-48",
    "JOB-49": "JOB-49",
    // "JOB-50": "JOB-50",
    "JOB-51": "JOB-51",
    "JOB-52": "JOB-52",
    // "JOB-53": "JOB-53",
    // "JOB-54": "JOB-54",
    // "JOB-55": "JOB-55",
    // "JOB-56": "JOB-56",
    // "JOB-57": "JOB-57",
    // "JOB-58": "JOB-58",
    // "JOB-59": "JOB-59",
    // "JOB-60": "JOB-60",
    // "JOB-61": "JOB-61",
    // "JOB-62": "JOB-62",
    // "JOB-63": "JOB-63",
    // "JOB-64": "JOB-64",
    // "JOB-65": "JOB-65",
    // "JOB-66": "JOB-66",
    "JOB-67": "JOB-67",
    "JOB-68": "JOB-68",
    // "JOB-69": "JOB-69",
    "JOB-70": "JOB-70",
    // "JOB-71": "JOB-71",
    // "JOB-72": "JOB-72",
    "JOB-73": "JOB-73",
    "JOB-74": "JOB-74",
    // "JOB-75": "JOB-75",
    "JOB-76": "JOB-76",
    "JOB-77": "JOB-77",
    "JOB-78": "JOB-78",
    // "JOB-79": "JOB-79",
    // "JOB-80": "JOB-80",
    "JOB-81": "JOB-81",
    "JOB-82": "JOB-82",
    "JOB-83": "JOB-83",
    // "JOB-84": "JOB-84",
    // "JOB-85": "JOB-85",
    // "JOB-86": "JOB-86",
    // "JOB-87": "JOB-87",
    // "JOB-88": "JOB-88",
    // "JOB-89": "JOB-89",
    // "JOB-90": "JOB-90",
    // "JOB-91": "JOB-91",
    // "JOB-92": "JOB-92",
    // "JOB-93": "JOB-93",
    // "JOB-94": "JOB-94",
    // "JOB-95": "JOB-95",
    // "JOB-96": "JOB-96",
    // "JOB-97": "JOB-97",
    // "JOB-98": "JOB-98",
    // "JOB-99": "JOB-99",
    "JOB-100": "JOB-100",
    "JOB-101": "JOB-101",
    // "JOB-102": "JOB-102",
    // "JOB-103": "JOB-103",
    // "JOB-104": "JOB-104",
    // "JOB-105": "JOB-105",
    "JOB-106": "JOB-106",
    // "JOB-107": "JOB-107",
    // "JOB-108": "JOB-108",
    // "JOB-109": "JOB-109",
    // "JOB-110": "JOB-110",
    // "JOB-111": "JOB-111",
    // "JOB-112": "JOB-112",
    // "JOB-113": "JOB-113",
    "JOB-114": "JOB-114",
    AGENTREQUEST: "AGENTREQUEST",
    PREMIUMCONF: "PREMIUMCONF",
    PREMIUMOTHER: "PREMIUMOTHER",
    AGENTOTHER: "AGENTOTHER",
    RETIREMENT: "RETIREMENT",
    NOTICE: "NOTICE",
    PAYMENTMANAGEMENT: "PAYMENTMANAGEMENT",
    AGENCY: "AGENCY",
    MENU: "MENU",
    REQUIREDPROCESSING: "REQUIREDPROCESSING",
    CONTRACTORHOME: "CONTRACTORHOME",
  },
};
